namespace Matrix.Workflow {
    export interface ApprovalRequest extends Serenity.ServiceRequest {
        WorkflowInstanceId?: number;
        Reject?: boolean;
        Comment?: string;
    }
}
